// Returns phone numbers in the form +17275551234
export const FormatPhoneNumber = (phoneNumberString: string) => {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return ['+1', match[2], match[3], match[4]].join('');
    }
    return null;
  }